<div class="wrapper d-none">
    <div class="page-wrapper pt-4">
        <div class="page-content pt-0 px-2">
            <div class="container-fluid">
                <div class="content-wrapper p-0">
                    <!-- <body> -->
                    <!-- <div class="dashboard-header">

                                    Institution Overview Dashboard
                                </div>
                                <div class="dashboard-box mb-2">
                                    <div class="filters p-2">
                                        <div class="row m-auto justify-content-center">
                                            <div class="col-md-3">
                                                <select class="form-select form-select-sm">
                                                    <option>Country: All</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <select class="form-select form-select-sm">
                                                    <option>Date: Jan 2022 - Dec 2022</option>
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <select class="form-select form-select-sm">
                                                    <option>Type: All Institutions</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                </div> -->
                    <!-- Main box -->
                    <div class="dashboard-box">
                        <!-- Stats -->
                        <div class="row g-0 text-center border-top border-bottom">
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small ">Total Institutions</div>
                                    <div class="fw-semibold fs-5">{{dbDetails?.TOTA_APPROVED_INST ?? 0}}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Active Institutions</div>
                                    <div class="fw-semibold fs-5">{{dbDetails?.TOTA_ACTIVE_INST ?? 0}}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md ">
                                <div class="py-2 border-end title1">
                                    <div class="small">Total Students</div>
                                    <div class="fw-semibold fs-5">{{dbDetails?.TOTAL_STUDENTS ?? 0}}</div>
                                </div>
                            </div>

                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">New Registrations</div>
                                    <div class="fw-semibold fs-5 text-warning">{{dbDetails?.TOTA_NEW_REGISTRATIONS ??
                                        0}}</div>
                                </div>
                            </div>
                            <div class="col-12 col-md">
                                <div class="py-2 border-end title1">
                                    <div class="small">Institutions Applications </div>
                                    <div class="fw-semibold fs-5">{{dbDetails?.TOTAL_REGISTRATION_INST ?? 0}}</div>
                                </div>
                            </div>
                            <!-- <div class="col-12 col-md">
                                            <div class="py-2">
                                                <div class="small" style="font-size: 14px; font-weight:500;">System
                                                    Usage</div>
                                                <div class="fw-semibold fs-5 d-flex justify-content-center align-items-center gap-2"
                                                    style="font-size: 26px; font-weight: bold;">
                                                    78%
                                                    <span><i class="bi bi-pie-chart-fill text-success"></i></span>
                                                </div>
                                            </div>
                                        </div> -->
                        </div>
                    </div>
                    <div class=" mt-2 mb-2">
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card">
                                    <div class="card-header bg-white fw-bold">Country Overview</div>
                                    <div class="card-body">
                                        <div class="row g-4">
                                            <!-- LEFT MAP CARD -->
                                            <div class="col-lg-7">
                                                <div class="card h-100">
                                                    <!-- <div #mapContainer style="height: 600px; width: 100%;"></div> -->
                                                    <div class="map-wrapper">
                                                        <div #mapContainer class="map-container"></div>
                                                    </div>

                                                </div>
                                                <!-- Replace image with actual SVG map if needed -->
                                            </div>
                                            <!-- RIGHT LINE CHART -->
                                            <div class="col-lg-5">
                                                <div class="row">
                                                    <div class="col-xl-12 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white">
                                                                <div class="card-title mb-0"> <strong> Top Counties by
                                                                        Institutions </strong></div>
                                                            </div>
                                                            <div class="card-body">
                                                                <canvas id="barChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-xl-12">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white">
                                                                <div class="card-title mb-0"> <strong> Monthly
                                                                    </strong> by Institutions</div>
                                                            </div> `
                                                            <div class="card-body">
                                                                <canvas id="lineChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- BAR CHART -->
                                            <!-- <div class="col-lg-6">
                                                        <div class="row">
                                                            <div class="col-xl-12">
                                                                <div class="card h-100">
                                                                    <div class="card-header bg-white">
                                                                        <div class="card-title mb-0"> <strong> Top Counties by
                                                                            Institutions </strong></div>
                                                                    </div>
                                                                    <div class="card-body">
                                                                        <canvas id="barChart"></canvas>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->
                                            <!-- REGISTRATION TREND -->
                                            <div class="col-lg-12">

                                                <div class="card h-100">
                                                    <div class="card-header bg-white">
                                                        <div class="card-title mb-0"> <strong> Registrations
                                                                Trend </strong></div>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="row">
                                                            <div class="col-md-6">
                                                                <canvas id="barChartmonth"></canvas>
                                                            </div>
                                                            <div class="col-md-6">
                                                                <canvas id="donutChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-2 mb-2">
                            <div class="col-xl-12">
                                <div class="card h-100 bg-transparent">
                                    <div class="card-header bg-white">
                                        <div class="card-title mb-0"> <strong> Central County Overview </strong>
                                        </div>
                                    </div>
                                    <div class="card-body bg-transparent">
                                        <div class="row">
                                            <div class="col-xl-6">
                                                <div class="card p-2" *ngIf="selectedCounty">
                                                    <small>County Level - <strong>{{ selectedCounty }}
                                                            County</strong></small>
                                                    <hr class="mt-0 mb-2">
                                                    <!-- <div #subMapContainer class="mt-3" style="height: 400px;"></div> -->
                                                    <div class="map-wrapper1">
                                                        <div #subMapContainer class="mt-3 map-container1"></div>
                                                    </div>
                                                    <!-- <div *ngIf="selectedCounty" class="mt-3">
                                                        <h5>{{ selectedCounty }} Sub-Counties</h5>
                                                    </div> -->
                                                </div>
                                            </div>
                                            <div class="col-xl-6">
                                                <!-- STATS -->
                                                <div class="row">
                                                    <div class="col-12 col-xl-6">
                                                        <div class="card stat-card">
                                                            <small>Total Institutions</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTAL_REGISTRATION_INST ?? 0}}</h4>
                                                                <span><i class="bi bi-bar-chart-fill"
                                                                        style="color: #2c67a5;"></i></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-xl-6">
                                                        <div class="card stat-card">
                                                            <small>Active Institutions</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTA_ACTIVE_INST ?? 0}}</h4>
                                                                <span><i
                                                                        class="bi bi-bar-chart-fill text-warning"></i></span>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-xl-6 mt-2">
                                                        <div class="card stat-card">

                                                            <small>Total Users</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTAL_STUDENTS ?? 0}}</h4>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <div class="col-12 col-xl-6 mt-2">
                                                        <div class="card stat-card">
                                                            <small>New Registrations</small>
                                                            <hr class="mt-0 mb-0">
                                                            <div
                                                                class="d-flex justify-content-between align-items-center">
                                                                <h4>{{countyDetails?.TOTA_NEW_REGISTRATIONS ?? 0}}</h4>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- CHARTS -->
                                                <div class="row g-2 mt-2">
                                                    <!-- BAR 1 -->
                                                    <div class="col-md-6 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white fw-semibold">
                                                                Sub-County Student Breakdown
                                                            </div>
                                                            <div class="card-body d-flex align-items-center">
                                                                <canvas id="breakdownbarChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- BAR 2 -->
                                                    <div class="col-md-6 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white fw-semibold">
                                                                Institutions by Sub-County
                                                            </div>
                                                            <div class="card-body d-flex align-items-center">
                                                                <canvas id="institutionsbarChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- DONUT -->
                                                    <div class="col-md-12 mb-2">
                                                        <div class="card h-100">
                                                            <div class="card-header bg-white fw-semibold">
                                                                Institution Types
                                                            </div>
                                                            <div class="card-body d-flex align-items-center">
                                                                <canvas id="subCountyDonutChart"></canvas>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- TOP SECTION -->
                        <div class="row">
                            <div class="col-xl-12">
                                <div class="card h-100">
                                    <div class="card-header bg-white">
                                        <div class="card-title mb-0"> <strong>Institution List</strong></div>
                                    </div>
                                    <div class="card-body">
                                        <div class="table-responsive" *ngIf="institutionsList.length">
                                            <table id="patreggraph" datatable
                                                class="table table-sm align-middle small table-striped"
                                                style="width: 100%;white-space: nowrap;" [dtOptions]="{ordering:false}">
                                                <thead class="bg-light">
                                                    <tr>
                                                        <th class="bg-light">Institution Name</th>
                                                        <th class="bg-light"> Type</th>
                                                        <th class="bg-light">Students</th>
                                                        <th class="bg-light">Active Students</th>
                                                        <th class="bg-light">Application Status</th>
                                                        <th class="bg-light">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let item of institutionsList">
                                                        <td>{{item.INSTITUTION_NAME}}</td>
                                                        <td>{{item.INSTITUTION_TYPE}}</td>
                                                        <td>{{item.TOTAL_STUDENTS}}</td>
                                                        <td>{{item.TOTAL_ACTIVE_STUDENTS}}</td>
                                                        <td>{{item.INSTITUTION_STATUS}}</td>
                                                        <td><span
                                                                class="status-active">{{item.INSTITUTION_STATUS}}</span>
                                                        </td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div>
                                        <div class="text-center" *ngIf="!institutionsList.length">
                                            No Records to Display
                                        </div>
                                        <!-- <div class="table-responsive">
                                            <table class="table table-sm align-middle small table-striped">
                                                <thead class="bg-light">
                                                    <tr>
                                                        <th class="bg-light">Institution Name</th>
                                                        <th class="bg-light"> Type</th>
                                                        <th class="bg-light">Students</th>
                                                        <th class="bg-light">Active Students</th>
                                                        <th class="bg-light">Application Status</th>
                                                        <th class="bg-light">Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody *ngIf="institutionsList.length !=0">
                                                    <tr *ngFor="let item of institutionsList">
                                                        <td>{{item.INSTITUTION_NAME}}</td>
                                                        <td>{{item.INSTITUTION_TYPE}}</td>
                                                        <td>{{item.TOTAL_STUDENTS}}</td>
                                                        <td>{{item.TOTAL_ACTIVE_STUDENTS}}</td>
                                                        <td>{{item.INSTITUTION_STATUS}}</td>
                                                        <td><span
                                                                class="status-active">{{item.INSTITUTION_STATUS}}</span>
                                                        </td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-xl-12">
                                <div #mapContainer style="height: 600px; width: 100%;"></div>
                            </div>
                            <div class="col-xl-12">
                                <div *ngIf="selectedCounty" class="mt-3">
                                    <h5>{{ selectedCounty }} Sub-Counties</h5>
                                    <div #subMapContainer style="height: 400px;"></div>
                                </div>
                            </div> -->
                        </div>
                        <!-- TABLE -->
                    </div>
                    <!-- </body> -->
                </div>
            </div>
        </div>
    </div>
</div>